import { search } from "./search";
import { filters } from "./filters";
import { wishlist } from "./wishlist";
import { shelfConfig } from "./shelfConfig";

export const catalog = {
    namespaced: true,
    modules: {
        search,
        filters,
        wishlist,
        shelfConfig
    }
};



// WEBPACK FOOTER //
// ./src/store/catalog/catalog.js